import React from 'react';
import './PreLaunchSurvey.css';

const PreLaunchSurvey: React.FC = () => {
  return (
    <section id="prelaunch-survey" className="prelaunch-survey">
      <div className="survey-container">
        <div className="survey-cta">
          <h2 className="survey-title">Help us build GetStrandX!</h2>
          <p className="survey-subtitle">
            Fill out this 2-minute survey to get early access. Tell us whether you're interested in
            roadside help, learning DIY car care, teaching others — or all of the above.
          </p>
        </div>
        
        <div className="survey-iframe-container">
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSekDGIjBxhYsjUTw6T1UEfoN7CiBLW8Q3V2TXhf1eiJiXQ4qw/viewform?embedded=true"
            width="100%"
            height="100%"
                    title="GetStrandX Pre-Launch Survey"
            className="survey-iframe"
          >Loading…</iframe>
        </div>
        
        <div className="survey-note">
          <p>Your feedback helps us build the best community platform for roadside help and DIY car care. Early access users will be notified when we launch!</p>
        </div>
      </div>
    </section>
  );
};

export default PreLaunchSurvey;
